import {DismissableInfoTile} from '#/atoms/dismissable-info-tile';
import {WalletContext} from '#/contexts/wallet-provider';
import {TransactionType} from '@shareland/shareland-common';
import {TFunction} from 'i18next';
import {ComponentProps, FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

const transactionsTextLink = {
  [TransactionType.Purchase]: {
    text: (t: TFunction<'translation'>) => t('pages.actionMenu.trade.sections.buy.informationLinkText'),
    link: 'https://shareland.notion.site/How-to-Buy-and-Sell-Tokens-5efb4d712ddd4dc6bccdb3e42ad3a529',
  },
  [TransactionType.Sell]: {
    text: (t: TFunction<'translation'>) => t('pages.actionMenu.trade.sections.sell.informationLinkText'),
    link: 'https://shareland.notion.site/How-to-Buy-and-Sell-Tokens-5efb4d712ddd4dc6bccdb3e42ad3a529',
  },
  Borrow: {
    text: (t: TFunction<'translation'>) => t('pages.actionMenu.trade.sections.borrow.informationLinkText'),
    link: 'https://shareland.notion.site/How-to-Borrow-Mint-and-Burn-Tokens-1ffab427777e4558ab6449d8454c390d',
  },
  [TransactionType.MintLiquidityToken]: {
    text: (t: TFunction<'translation'>) => t('pages.actionMenu.rent.sections.rent.informationLinkText'),
    link: 'https://shareland.notion.site/How-to-Stake-Tokens-and-Claim-Rewards-5ccc641623944f9a9b21d1cdb94f8370',
  },
  [TransactionType.BurnLiquidityToken]: {
    text: (t: TFunction<'translation'>) => t('pages.actionMenu.rent.sections.stopRent.informationLinkText'),
    link: 'https://shareland.notion.site/How-to-Stake-Tokens-and-Claim-Rewards-5ccc641623944f9a9b21d1cdb94f8370',
  },
  [TransactionType.ClaimRewards]: {
    text: (t: TFunction<'translation'>) => t('pages.actionMenu.rent.sections.claim.informationLinkText'),
    link: 'https://shareland.notion.site/How-to-Stake-Tokens-and-Claim-Rewards-5ccc641623944f9a9b21d1cdb94f8370',
  },
};

type ActionMenuInfoTileKey = keyof typeof transactionsTextLink;

export const ActionMenuInfoTile: FunctionComponent<
  {tileKey: ActionMenuInfoTileKey} & Pick<ComponentProps<typeof DismissableInfoTile>, 'onClose'>
> = ({tileKey, onClose, ...rest}) => {
  const {
    accountResult: {isConnected},
  } = useContext(WalletContext);

  const {t} = useTranslation('translation');

  const {text, link} = transactionsTextLink[tileKey];
  return (
    <DismissableInfoTile to={link} onClose={isConnected ? onClose : undefined} {...rest}>
      {text(t)}
    </DismissableInfoTile>
  );
};
